import { action, observable } from 'mobx'
import { DocumentRequest } from '../requests/DocumentRequest'

class PhieuTrinhFakeDataStore {
  @observable attachment = undefined
  @observable showModalApprover = false
  @observable listRecord = []
  @observable recordDetail = {}
  @observable totalCount = 0
  @observable filterTable = {
    isOpen: false,
    leave_form_name: '',
    page: 1,
    size: 10,
  }

  @action showModal = modalName => {
    this[modalName] = true
  }
  @action hideModal = modalName => {
    this[modalName] = false
  }

  @action setFilter = filter => {
    this.filterTable = Object.assign({}, this.filterTable, filter)
  }

  @action getListLeave = (payload, loaiPhieuTrinh) => {
    return new Promise((resolve, reject) => {
      this.totalCount = Math.floor(Math.random() * 999999)
      this.listRecord = []

      for (
        let index = 0;
        index <
        (this.totalCount > this.filterTable.size
          ? this.filterTable.size
          : this.totalCount);
        index++
      ) {
        this.listRecord.push({
          id: Math.floor(Math.random() * 999999),
          stt: index + 1,
          title: `${loaiPhieuTrinh} số ` + Math.floor(Math.random() * 999999),
          description: 'Vì lí do ' + Math.floor(Math.random() * 999999),
          status: Math.floor(Math.random() * 4), // 0: chờ phê duyệt, 1: đã duyệt phiếu, 2: huỷ phiếu, 3: cần phê duyệt
          from_date: new Date(),
          to_date: new Date(),
          createdAt: new Date(),
          updatedAt: new Date(),
          createdBy: `admin${
            [Math.floor(Math.random() * 999999), ''][
              Math.floor(Math.random() * 2)
            ]
          }@gmail.com`,
          file_id: '5f9d3110de1ef178272d11ba',
          file_name: 'JD_Frontend Developer.pdf',
          assignee: 'user' + Math.floor(Math.random() * 999999) + '@gmail.com',
          job_hand_over: 'ABC' + Math.floor(Math.random() * 999999),
          approve: {
            list: [
              [
                {
                  id: Math.floor(Math.random() * 999999),
                  name: 'Approver' + Math.floor(Math.random() * 999999),
                  status: 0, // 0: chưa duyệt, 1: đã duyệt phiếu, 2: huỷ phiếu
                },
                {
                  id: Math.floor(Math.random() * 999999),
                  name: 'Approver' + Math.floor(Math.random() * 999999),
                  status: 1, // 0: chưa duyệt, 1: đã duyệt phiếu, 2: huỷ phiếu
                },
                {
                  id: Math.floor(Math.random() * 999999),
                  name: 'Approver' + Math.floor(Math.random() * 999999),
                  status: 2, // 0: chưa duyệt, 1: đã duyệt phiếu, 2: huỷ phiếu
                },
              ],
              [
                {
                  id: Math.floor(Math.random() * 999999),
                  name: 'Approver' + Math.floor(Math.random() * 999999),
                  status: 0, // 0: chưa duyệt, 1: đã duyệt phiếu, 2: huỷ phiếu
                },
              ],
              [
                {
                  id: Math.floor(Math.random() * 999999),
                  name: 'Approver' + Math.floor(Math.random() * 999999),
                  status: 0, // 0: chưa duyệt, 1: đã duyệt phiếu, 2: huỷ phiếu
                },
              ],
            ],
          },
          comment: [
            {
              name: 'Approver' + Math.floor(Math.random() * 999999),
              text: 'text' + Math.floor(Math.random() * 999999),
              fileId: 'File' + Math.floor(Math.random() * 999999),
              fileName: 'Name' + Math.floor(Math.random() * 999999),
              status: Math.floor(Math.random() * 3), // 0: chỉ comment, 1: duyệt phiếu, 2: huỷ phiếu
            },
            {
              name: 'Approver' + Math.floor(Math.random() * 999999),
              text: 'text' + Math.floor(Math.random() * 999999),
              fileId: 'File' + Math.floor(Math.random() * 999999),
              fileName: 'Name' + Math.floor(Math.random() * 999999),
              status: Math.floor(Math.random() * 3), // 0: chỉ comment, 1: duyệt phiếu, 2: huỷ phiếu
            },
            {
              name: 'Approver' + Math.floor(Math.random() * 999999),
              text: 'text' + Math.floor(Math.random() * 999999),
              fileId: 'File' + Math.floor(Math.random() * 999999),
              fileName: 'Name' + Math.floor(Math.random() * 999999),
              status: Math.floor(Math.random() * 3), // 0: chỉ comment, 1: duyệt phiếu, 2: huỷ phiếu
            },
          ],
        })
      }
      resolve()
    })
  }

  @action getRecordDetailById = (id, loaiPhieuTrinh) => {
    return new Promise((resolve, reject) => {
      const tmp = {
        id: Math.floor(Math.random() * 999999),
        title: `${loaiPhieuTrinh} số ` + Math.floor(Math.random() * 999999),
        description: 'Vì lí do ' + Math.floor(Math.random() * 999999),
        status: Math.floor(Math.random() * 4), // 0: chờ phê duyệt, 1: đã duyệt phiếu, 2: huỷ phiếu, 3: cần phê duyệt
        from_date: new Date(),
        to_date: new Date(),
        createdAt: new Date(),
        updatedAt: new Date(),
        createdBy: `admin${
          [Math.floor(Math.random() * 999999), ''][
            Math.floor(Math.random() * 2)
          ]
        }@gmail.com`,
        file_id: '5f9d3110de1ef178272d11ba',
        file_name: 'JD_Frontend Developer.pdf',
        assignee: 'user' + Math.floor(Math.random() * 999999) + '@gmail.com',
        job_hand_over: 'ABC' + Math.floor(Math.random() * 999999),
        approve: {
          list: [
            [
              {
                id: Math.floor(Math.random() * 999999),
                name: 'Approver' + Math.floor(Math.random() * 999),
                status: 0, // 0: chưa duyệt, 1: đã duyệt phiếu, 2: huỷ phiếu
              },
              {
                id: Math.floor(Math.random() * 999999),
                name: 'Approver' + Math.floor(Math.random() * 999),
                status: 1, // 0: chưa duyệt, 1: đã duyệt phiếu, 2: huỷ phiếu
              },
              {
                id: Math.floor(Math.random() * 999999),
                name: 'Approver' + Math.floor(Math.random() * 999),
                status: 2, // 0: chưa duyệt, 1: đã duyệt phiếu, 2: huỷ phiếu
              },
            ],
            [
              {
                id: Math.floor(Math.random() * 999999),
                name: 'Approver' + Math.floor(Math.random() * 999),
                status: 0, // 0: chưa duyệt, 1: đã duyệt phiếu, 2: huỷ phiếu
              },
            ],
            [
              {
                id: Math.floor(Math.random() * 999999),
                name: 'Approver' + Math.floor(Math.random() * 999),
                status: 0, // 0: chưa duyệt, 1: đã duyệt phiếu, 2: huỷ phiếu
              },
            ],
          ],
        },
        comment: [
          {
            name: 'Approver' + Math.floor(Math.random() * 999999),
            text: 'text' + Math.floor(Math.random() * 999999),
            fileId: 'File' + Math.floor(Math.random() * 999999),
            fileName: 'Name' + Math.floor(Math.random() * 999999),
            status: Math.floor(Math.random() * 3), // 0: chỉ comment, 1: duyệt phiếu, 2: huỷ phiếu
          },
          {
            name: 'Approver' + Math.floor(Math.random() * 999999),
            text: 'text' + Math.floor(Math.random() * 999999),
            fileId: 'File' + Math.floor(Math.random() * 999999),
            fileName: 'Name' + Math.floor(Math.random() * 999999),
            status: Math.floor(Math.random() * 3), // 0: chỉ comment, 1: duyệt phiếu, 2: huỷ phiếu
          },
          {
            name: 'Approver' + Math.floor(Math.random() * 999999),
            text: 'text' + Math.floor(Math.random() * 999999),
            fileId: 'File' + Math.floor(Math.random() * 999999),
            fileName: 'Name' + Math.floor(Math.random() * 999999),
            status: Math.floor(Math.random() * 3), // 0: chỉ comment, 1: duyệt phiếu, 2: huỷ phiếu
          },
        ],
      }
      this.recordDetail = tmp
      resolve({
        data: tmp,
      })
    })
  }

  @action getViewAttachment = payload => {
    return new Promise((resolve, reject) => {
      // TODO: need change
      DocumentRequest.getViewAttachmentISO(payload)
        .then(response => {
          this.attachment = new Blob([response.data], {
            type: 'application/pdf',
          })
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getAttachment = payload => {
    return new Promise((resolve, reject) => {
      // TODO: need change
      DocumentRequest.getAttachmentISO(payload)
        .then(response => {
          this.attachment = new Blob([response.data], {
            type: 'application/pdf',
          })
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action clearLeaveData = () => {
    this.listRecord = []
    this.totalCount = 0
  }

  @action clearLeaveDataDetail = () => {
    this.recordDetail = {}
    this.attachment = undefined
  }
}

export default new PhieuTrinhFakeDataStore()
